export const AppStoreRating = "4,6 · 869 anmeldelser";
export const GooglePlayRating = "4,4 · 765 anmeldelser";

export const RateExampleRefinance =
  "147\u00A0000\u00A0kr over 7\u00A0år, effektiv rente 13,59%, kostnad 76\u00A0101\u00A0kr, totalt 223\u00A0101\u00A0kr";
export const RateExampleConsumerLoan =
  "147\u00A0000 kr over 7 år, effektiv rente 13,59 %, kostnad 76\u00A0101 kr, totalt 223\u00A0101 kr";
export const RateExampleRestartLoan =
  "Effektiv rente på 8,55 % ved et lån på 2 millioner over 25 år, kostnad 2\u00A0622\u00A0146 kr, totalt 4\u00A0622\u00A0146 kr";
